<app-section-grid [subSection]="'Create Video Template'"></app-section-grid>

<app-stepper-grid></app-stepper-grid>

<div class="relative w-full max-w-4xl mx-auto p-10 bg-white rounded-3xl border border-gray-200 mb-5">

    <form [formGroup]="videoTemplateForm" (ngSubmit)="onSubmit()">
        <!-- Header -->
        <div class="text-center mb-10">
            <h1 class="text-3xl font-bold text-gray-800 tracking-tight">
                Video Template Details
            </h1>
            <p class="mt-2 text-gray-500">
                Enter the video template details below.
            </p>
        </div>

        <!-- Centered fields block -->
        <div class="w-full max-w-2xl mx-auto">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                <!-- Template Name -->
                <div class="mb-2">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        🏷 Video Template Name
                    </label>

                    <input formControlName="template_name" placeholder="Enter video template name..." class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors" />

                    <div *ngIf="videoTemplateForm.get('template_name')?.touched && videoTemplateForm.get('template_name')?.invalid"
                        class="mt-1 text-xs text-red-500">
                        Video Template Name is required.
                    </div>
                </div>

                <!-- Template ID -->
                <div class="mb-2">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        🆔 Template ID
                    </label>

                    <input formControlName="template_id" placeholder="Enter template ID..." class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors" />

                    <div *ngIf="videoTemplateForm.get('template_id')?.touched && videoTemplateForm.get('template_id')?.invalid"
                        class="mt-1 text-xs text-red-500">
                        Template ID is required.
                    </div>
                </div>

                <!-- Slides Number -->
                <div class="mb-2">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        🖼 Slides Number
                    </label>

                    <input type="number" formControlName="slides_number" placeholder="Enter number of slides..." class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors" />

                    <div *ngIf="videoTemplateForm.get('slides_number')?.touched && videoTemplateForm.get('slides_number')?.invalid"
                        class="mt-1 text-xs text-red-500">
                        Slides Number is required.
                    </div>
                </div>

                <!-- RSS Feed -->
                <div class="mb-2">
                    <label class="block text-sm font-semibold text-gray-700 mb-2">
                        📡 Post Category
                    </label>

                    <select formControlName="rss_feed_id" class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
                        <option value="">Select Category</option>
                        <option *ngFor="let feed of selectOptions.feeds" [value]="feed.id"
                            [disabled]="feed.url === 'default'">
                            {{ feed.feed }} {{ feed.url === 'default' ? '(Default)' : '' }}
                        </option>
                    </select>

                    <div *ngIf="videoTemplateForm.get('rss_feed_id')?.touched && videoTemplateForm.get('rss_feed_id')?.invalid"
                        class="mt-1 text-xs text-red-500">
                        Feed Category is required.
                    </div>
                </div>

            </div>

            <app-submit-grid></app-submit-grid>

        </div>

    </form>

</div>

<app-footer-grid></app-footer-grid>